(function () {
  const popup = document.getElementById('geo-redirect-popup');
  if (!popup) return;
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? match[1] : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  if (getCookie('geo_redirect_dismissed')) return;

  const targetCountry = (popup.dataset.country || '').toUpperCase();
  if (!targetCountry) return;

  var token = popup.dataset.ipinfoToken;
  var url = token
    ? 'https://ipinfo.io/json?token=' + token
    : 'https://ipinfo.io/json';

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
if ((data.country || '').toUpperCase() === targetCountry) {
        popup.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden');
      }
    })
    .catch(function () {});

  function dismiss() {
    setCookie('geo_redirect_dismissed', '1', 30);
    popup.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }

  document.getElementById('geo-redirect-no').addEventListener('click', dismiss);
  popup.querySelector('.geo-redirect-popup__overlay').addEventListener('click', dismiss);
})();
